import styled from 'styled-components';

const FormErrorStyles = styled.div`
  margin-right: auto;
  color: var(--color-error);

  @media (min-width: 768px) {
    width: 60%;
    max-width: 45rem;
  }
`;

export default FormErrorStyles;
